<template>
    <div class="breadcrumb-wrapper">
        <div class="container booking-step">
            <div class="row gap-0">
                <div class="col-xs-12 col-sm-4">
                    <div class="step-item active">
                        <div class="line"></div>
                        <div class="step-item">
                            <div class="number">
                                <div class="inner">1</div>
                            </div>
                            <p>Selección de Sala </p>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4">
                    <div class="step-item active">
                        <div class="line"></div>
                        <div class="step-item">
                            <div class="number">
                                <div class="inner">2</div>
                            </div>
                            <p>Detalles de Reserva</p>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4">
                    <div class="step-item active">
                        <div class="line"></div>
                        <div class="step-item">
                            <div class="number">
                                <div class="inner">3</div>
                            </div>
                            <p>Confirmación</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "breadCumb"
    }
</script>

<style scoped>
    .line {
        background: #868686 !important;
    }

    .step-item {
        color: #8ac6c4 !important;
    }

    .step-item.active .number .inner {
        background: #8ac6c4 !important;
    }
</style>